export default __webpack_public_path__ + "static/media/australia.23c1de00.svg";